import routerOptions0 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.12.2_@libsql+client@0.7.0_@opentelemetry+api@1.9.0_@parcel+watcher@2.4.1_@types+node@2_gm6h4ae3zehumf3jphifg4vvma/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}